export default "__VITE_PUBLIC_ASSET__4a62717f__"